/** Angular stuff */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/** Third parties */
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
/** Design System */
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzUploadModule } from 'ng-zorro-antd/upload';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NgxDatatableModule,

    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzDividerModule,
    NzSwitchModule,
    NzTabsModule,
    NzCollapseModule,
    NzSpaceModule,
    NzBadgeModule,
    NzSelectModule,
    NzGridModule,
    NzDatePickerModule,
    NzTagModule,
    NzRadioModule,
    NzCheckboxModule,
    NzInputNumberModule,
    NzModalModule,
    NzSpinModule,
    NzNotificationModule,
    NzAutocompleteModule,
    NzAlertModule,
    NzAffixModule,
    NzTimelineModule,
    NzResultModule,
    NzToolTipModule,
    NzIconModule,
    NzEmptyModule,
    NzBreadCrumbModule,
    NzSkeletonModule,
    NzLayoutModule,
    NzMenuModule,
    NzDropDownModule,
    NzCardModule,
    NzProgressModule,
    NzPopoverModule,
    NzPopconfirmModule,
    NzUploadModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NgxDatatableModule,

    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzResultModule,
    NzDividerModule,
    NzSwitchModule,
    NzTabsModule,
    NzCollapseModule,
    NzSpaceModule,
    NzBadgeModule,
    NzSelectModule,
    NzGridModule,
    NzDatePickerModule,
    NzTagModule,
    NzRadioModule,
    NzCheckboxModule,
    NzInputNumberModule,
    NzModalModule,
    NzSpinModule,
    NzNotificationModule,
    NzAutocompleteModule,
    NzAlertModule,
    NzAffixModule,
    NzTimelineModule,
    NzToolTipModule,
    NzIconModule,
    NzEmptyModule,
    NzBreadCrumbModule,
    NzSkeletonModule,
    NzLayoutModule,
    NzMenuModule,
    NzDropDownModule,
    NzCardModule,
    NzProgressModule,
    NzPopoverModule,
    NzPopconfirmModule,
    NzUploadModule,
  ],
})
export class SharedModule {}
